import DisabledTextField from '../DisabledTextField';
import BooleanField from '../BooleanField';
import DateRangeField from '../DateRangeField';
import MultiSelectField from '../MultiSelectField';
import NumberRangeField from '../NumberRangeField';
import TextField from '../TextField';

export default function resolveDynamicFieldRenderer(
  field: UCM.DynamicFieldType,
) {
  switch (field.type.code) {
    case 'boolean':
      return BooleanField;
    case 'multi-selectable':
    case 'single-selectable':
      return MultiSelectField;
    case 'date':
      return DateRangeField;
    case 'number':
      return NumberRangeField;
    case 'text':
      return TextField;
    default:
      return DisabledTextField;
  }
}
